import { ProductSolrDTO } from "./product-solr";
import { DecodeBase64Pipe } from '@signature-it/ngx-generic/pipes';

export class ProductFullSolrDTO extends ProductSolrDTO {
    private readonly DEFAULT_CURRENCY = 'USD';
    private readonly INVALID_CONDITION = 'Invalid Condition';

    decodeBase64Pipe: any = new DecodeBase64Pipe();
    
    Description_Subtitle_s: string;
    Detailed_Description_s: string;
    Extra_Link_s: string;
    Extra_Link_Description_s: string;
    pay_attention_s: string;
    Payment_Properties_ss: Array<string>;
    note_activity_s: string;
    price: number;
    price_currency: string;
    ManufacturerNo_s: string;
    BrandName_s: string;
    UNSPSC_s: string;
    PackSize_s: number;
    ProductName_s: string;
    product_name_s: string;
    product_code_s: string;
    product_pic_s: string;
    product_drw_s: string;
    popular_s: string;
    attachment_link1_s: string;
    attachment_title1_s: string;
    attachment_link2_s: string;
    attachment_title2_s: string;
    attachment_link3_s: string;
    attachment_title3_s: string;
    Certificate_filename_1_s: string;
    Certificate_filename_2_s: string;
    Certificate_filename_3_s: string;
    Certificate_filename_4_s: string;
    Certificate_path_1_s: string;
    Certificate_path_2_s: string;
    Certificate_path_3_s: string;
    Certificate_path_4_s: string;
    valid: boolean;
    status: string;
    productTemplate: string;
    productTemplateCustomVar: string;
    cngTemplateHeaderCms: string;
    cngTemplateContentCms: string;
    variety_block_s: number;
    field1_H_s: string;
    field2_H_s: string;
    field3_H_s: string;
    field4_H_s: string;
    field5_H_s: string;
    field6_H_s: string;
    field1_V_s: string;
    field2_V_s: string;
    field3_V_s: string;
    field4_V_s: string;
    field5_V_s: string;
    field6_V_s: string;
    Brand_s: string;
    Logo_s: string;
    More_Information_Or_Comments_s: string;
    related_open_rule_1_s: string;
    related_open_rule_2_s: string;
    related_open_rule_3_s: string;
    related_open_rule_4_s: string;
    related_open_rule_5_s: string;
    related_open_rule_title_1_s: string;
    related_open_rule_title_2_s: string;
    related_open_rule_title_3_s: string;
    related_open_rule_title_4_s: string;
    related_open_rule_title_5_s: string;
    cancel_policy_entity_var_s: string;
    pickup_entity_var_s: string;
    supply_days_s: string;
    delivery_price_s: string;
    promotion: string;
    product_page_content_lg: string;
    fullUrl: string;
    Product_Description_s: string;

    constructor(attributes?: object) {
        super(attributes);
        attributes = attributes || {};
        // properties set in ProductSolrDTO need to be in attributes
        Object.assign(attributes, this);
        // all attributes need to be on this
        Object.assign(this, attributes);
        this.Description_Subtitle_s = attributes['Description_Subtitle_s'] || "";
        this.Detailed_Description_s = attributes['Detailed_Description_s'] || "";
        this.Extra_Link_s = attributes['Extra_Link_s'] || "";
        this.Extra_Link_Description_s = attributes['Extra_Link_Description_s'] || "";
        this.pay_attention_s = attributes['pay_attention_s'] || "";
        this.Payment_Properties_ss = attributes['Payment_Properties_ss'] || "";
        this.note_activity_s = attributes['note_activity_s'] || "";
        this.setPriceAndCurrency(attributes['list_price_c'] || "");
        this.ManufacturerNo_s = attributes['ManufacturerNo_s'] || "";
        this.BrandName_s = attributes['BrandName_s'] || "";
        this.UNSPSC_s = attributes['UNSPSC_s'] || "";
        this.PackSize_s = Number(attributes['PackSize_s']) || 1;
        this.ProductName_s = attributes['ProductName_s'] || "";
        this.product_name_s = attributes['product_name_s'] || "";
        this.product_code_s = attributes['product_code_s'] || "";
        this.product_pic_s = attributes['product_pic_s'] || "";
        this.product_drw_s = attributes['product_drw_s'] || "";
        this.popular_s = attributes['popular_s'] || "";
        this.attachment_link1_s = attributes['attachment_link1_s'] || "";
        this.attachment_title1_s = attributes['attachment_title1_s'] || "";
        this.attachment_link2_s = attributes['attachment_link2_s'] || "";
        this.attachment_title2_s = attributes['attachment_title2_s'] || "";
        this.attachment_link3_s = attributes['attachment_link3_s'] || "";
        this.attachment_title3_s = attributes['attachment_title3_s'] || "";
        this.Certificate_filename_1_s = attributes['Certificate_filename_1_s'] || "";
        this.Certificate_filename_2_s = attributes['Certificate_filename_2_s'] || "";
        this.Certificate_filename_3_s = attributes['Certificate_filename_3_s'] || "";
        this.Certificate_filename_4_s = attributes['Certificate_filename_4_s'] || "";
        this.Certificate_path_1_s = attributes['Certificate_path_1_s'] || "";
        this.Certificate_path_2_s = attributes['Certificate_path_2_s'] || "";
        this.Certificate_path_3_s = attributes['Certificate_path_3_s'] || "";
        this.Certificate_path_4_s = attributes['Certificate_path_4_s'] || "";
        this.productTemplate = attributes['product_template_s'] || "";
        this.productTemplateCustomVar = attributes['product_template_custom_var_s'] || "";
		this.valid = attributes['valid'] || true;
		this.cngTemplateHeaderCms = attributes['cng_template_header_cms_s'] || "";
		this.cngTemplateContentCms = attributes['cng_template_content_cms_s'] || "";
		this.variety_block_s = attributes['variety_block_s'] || "";
		this.field1_H_s = attributes['Field1_H_s'] || "";
		this.field2_H_s = attributes['Field2_H_s'] || "";
		this.field3_H_s = attributes['Field3_H_s'] || "";
		this.field4_H_s = attributes['Field4_H_s'] || "";
		this.field5_H_s = attributes['Field5_H_s'] || "";
		this.field6_H_s = attributes['Field6_H_s'] || "";
		this.field1_V_s = attributes['Field1_V_s'] || "";
		this.field2_V_s = attributes['Field2_V_s'] || "";
		this.field3_V_s = attributes['Field3_V_s'] || "";
		this.field4_V_s = attributes['Field4_V_s'] || "";
		this.field5_V_s = attributes['Field5_V_s'] || "";
		this.field6_V_s = attributes['Field6_V_s'] || "";
		this.Brand_s = attributes['Brand_s'] || "";
		this.Logo_s = attributes['Logo_s'] || "";
		this.More_Information_Or_Comments_s = attributes['More_Information_Or_Comments_s'] || "";
        this.related_open_rule_1_s = attributes['related_open_rule_1_s'] != this.INVALID_CONDITION ? attributes['related_open_rule_1_s'] || "" : '';
        this.related_open_rule_2_s = attributes['related_open_rule_2_s'] != this.INVALID_CONDITION ? attributes['related_open_rule_2_s'] || "" : '';
        this.related_open_rule_3_s = attributes['related_open_rule_3_s'] != this.INVALID_CONDITION ? attributes['related_open_rule_3_s'] || "" : '';
        this.related_open_rule_4_s = attributes['related_open_rule_4_s'] != this.INVALID_CONDITION ? attributes['related_open_rule_4_s'] || "" : '';
        this.related_open_rule_5_s = attributes['related_open_rule_5_s'] != this.INVALID_CONDITION  ?attributes['related_open_rule_5_s'] || "" : '';
        this.related_open_rule_title_1_s = attributes['related_open_rule_title_1_s'] || "";
        this.related_open_rule_title_2_s = attributes['related_open_rule_title_2_s'] || "";
        this.related_open_rule_title_3_s = attributes['related_open_rule_title_3_s'] || "";
        this.related_open_rule_title_4_s = attributes['related_open_rule_title_4_s'] || "";
        this.related_open_rule_title_5_s = attributes['related_open_rule_title_5_s'] || "";
        this.cancel_policy_entity_var_s = attributes['cancel_policy_entity_var_s'] || "";
        this.pickup_entity_var_s = attributes['pickup_entity_var_s'] || "";
        this.supply_days_s = attributes['supply_days_s'] || "";
        this.delivery_price_s = attributes['delivery_price_s'] || "";
        this.promotion = attributes['promotion'] || "";
        this.product_page_content_lg = attributes['product_page_content_lg'] || "";
        this.fullUrl = `${location.hostname}${this.getUrl()}`;
        this.Product_Description_s  =  this.decodeBase64Pipe.decode(attributes['Product_Description_base64']) || attributes['Product_Description_s'] || "";
    }

    protected setPriceAndCurrency(list_price_c: string) {
        const parts = list_price_c.split(',');
        this.price = Number(parts[0]) || 0;
        this.price_currency = parts[1] || this.DEFAULT_CURRENCY;
    }


}
